import { render, staticRenderFns } from "./RecentAccessLearner.vue?vue&type=template&id=b19e1bb4&scoped=true"
import script from "./RecentAccessLearner.vue?vue&type=script&lang=js"
export * from "./RecentAccessLearner.vue?vue&type=script&lang=js"
import style0 from "./RecentAccessLearner.vue?vue&type=style&index=0&id=b19e1bb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b19e1bb4",
  null
  
)

export default component.exports